import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <g transform="matrix(0 -1 -1 0 20 10)">
        <rect transform="matrix(-1 0 0 1 8 0)" width="8" height="6" rx="2" />
        <path d="M6 6v8l-2 2-2-2v-2l1-1-1-2V6z" />
      </g>
      <path d="m21.5606 16.6543-8.246 3.7482a4 4 0 0 1-2.7077.2176L1 18v-5h10.5c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5H8h5l7.5-2.5c.8284-.2761 1.7239.1716 2 1 .2842.8527-.1212 1.7824-.9394 2.1543Z" />
    </g>
  </svg>
);
